"use strict";
// Copyright (c) StrangeBee 2023
Object.defineProperty(exports, "__esModule", { value: true });
exports.alertDefaultFields = exports.alertFields = exports.logDefaultFields = exports.logFields = exports.ttpDefaultFields = exports.ttpFields = exports.taskDefaultFields = exports.taskFields = exports.observableDefaultFields = exports.observableFields = exports.ReportTemplateWidgetEnum = void 0;
var ReportTemplateWidgetEnum;
(function (ReportTemplateWidgetEnum) {
    ReportTemplateWidgetEnum["Text"] = "Text";
    ReportTemplateWidgetEnum["Image"] = "Image";
    ReportTemplateWidgetEnum["ObservableTable"] = "ObservableTable";
    ReportTemplateWidgetEnum["TaskTable"] = "TaskTable";
    ReportTemplateWidgetEnum["AlertTable"] = "AlertTable";
    ReportTemplateWidgetEnum["TTPTable"] = "TTPTable";
    ReportTemplateWidgetEnum["ObservableList"] = "ObservableList";
    ReportTemplateWidgetEnum["TaskList"] = "TaskList";
    ReportTemplateWidgetEnum["AlertList"] = "AlertList";
    ReportTemplateWidgetEnum["TTPList"] = "TTPList";
    ReportTemplateWidgetEnum["CustomFields"] = "CustomFields";
    ReportTemplateWidgetEnum["Table"] = "Table";
    ReportTemplateWidgetEnum["List"] = "List";
})(ReportTemplateWidgetEnum = exports.ReportTemplateWidgetEnum || (exports.ReportTemplateWidgetEnum = {}));
exports.observableFields = [
    'dataType',
    'data',
    'startDate',
    'tlp',
    'pap',
    'tags',
    'ioc',
    'sighted',
    'sightedAt',
    'reports',
    'message',
    '_createdAt',
    '_createdBy',
    '_updatedAt',
    '_updatedBy',
];
exports.observableDefaultFields = ['dataType', 'data', '_createdAt', 'tlp'];
exports.taskFields = [
    'group',
    'title',
    'description',
    'status',
    'flag',
    'startDate',
    'endDate',
    'assignee',
    'dueDate',
    'mandatory',
    '_createdAt',
    '_createdBy',
    '_updatedAt',
    '_updatedBy',
];
exports.taskDefaultFields = ['title', 'group', 'assignee', 'status', 'startDate'];
exports.ttpFields = [
    'tactic',
    'patternId',
    'description',
    'occurDate',
    '_createdAt',
    '_createdBy',
    '_updatedAt',
    '_updatedBy',
];
exports.ttpDefaultFields = ['tactic', 'patternId', 'occurDate', '_createdBy'];
exports.logFields = [
    'message',
    'date',
    'includeInTimeline',
    '_createdAt',
    '_createdBy',
    '_updatedAt',
    '_updatedBy',
];
exports.logDefaultFields = ['_createdBy', '_createdAt', 'message'];
exports.alertFields = [
    'type',
    'source',
    'sourceRef',
    'externalLink',
    'title',
    'description',
    'severity',
    'date',
    'tags',
    'tlp',
    'pap',
    'status',
    'stage',
    'assignee',
    'summary',
    'inProgressDate',
    'closedDate',
    'importedDate',
    'timeToDetect',
    'timeToTriage',
    'timeToQualify',
    'timeToAcknowledge',
    '_createdAt',
    '_createdBy',
    '_updatedAt',
    '_updatedBy',
    '_id',
];
exports.alertDefaultFields = ['_id', 'title', 'severity', 'assignee'];
